module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0153.jpg?v=dd1ae974";